export function contains( value: string, toCheck?: string | RegExp ): boolean {
   if ( !value || !toCheck ) { return true; }

   value = value.trim().toLowerCase();

   if ( toCheck instanceof RegExp ) {
      return toCheck.test( value );
   } else {
      return value.includes( toCheck.trim().toLowerCase() );
   }
}
